import { render } from "./FilterChip.vue?vue&type=template&id=0fac045c"
import script from "./FilterChip.vue?vue&type=script&lang=js"
export * from "./FilterChip.vue?vue&type=script&lang=js"

import "../styles/FilterChip.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__